module.exports = __webpack_public_path__ + "img/okx.1cbc268f.png";